import { useAppSelector } from "../../app/hooks";
import styles from "./RiskProfileTable.module.scss";
import { headers } from "./i18n";

const RiskProfileTable = () => {
  const { table } = styles;

  const {
    interactiveBrokers: { availableRiskProfiles: riskProfileRows },
    onboardingData: { language = "es" },
  } = useAppSelector((state) => state);

  return (
    <table className={table}>
      <tr>
        <th rowSpan={2}>{headers[language].name}</th>
        <th rowSpan={2}>{headers[language].maxEquity}</th>
        <th colSpan={2}>{headers[language].weight}</th>
      </tr>
      <tr>
        <th>{headers[language].equity}</th>
        <th>{headers[language].fixedIncome}</th>
      </tr>

      {riskProfileRows?.map(({ name, maxEquity, equity, fixedIncome }) => (
        <tr>
          <td>{name}</td>
          <td>{maxEquity}%</td>
          <td>{equity}%</td>
          <td>{fixedIncome}%</td>
        </tr>
      ))}
    </table>
  );
};

export default RiskProfileTable;
